import axios from "axios";
import config from "./config.json";
import MessageData from "./types/MessageData";

class WidgetService {
  private http = axios.create({
    baseURL: config.tecobi.api.baseURL
  });

  async getWidgetConfig(clientId: any) {
    return await this.http.request({
      method: "GET",
      url: `/client-widgets/${clientId}/`
    });
  }

  async createMessage(data: MessageData) {
    return await this.http.request({
      method: "POST",
      url: "/sms-widget/",
      data
    });
  }
}

export default new WidgetService();
